class ScalpCareCourse extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeyDown);
    this.querySelector('dialog')?.close();
  }

  handleKeyDown = (event) => {
    const dialog = this.querySelector('dialog[open]');
    if (!dialog || event.key !== 'Tab') return;

    const controls = dialog.querySelectorAll('button, a[href]');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };

  handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    if (event.target.closest('[data-course-open]')) {
      if (!dialog.open) dialog.showModal();
    } else if (event.target.closest('[data-course-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (
        event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom
      ) {
        dialog.close();
      }
    }
  };
}

if (!customElements.get('scalp-care-course')) {
  customElements.define('scalp-care-course', ScalpCareCourse);
}
